<template>
  <div style="position: relative;">
    <div class="overlay" @click="$emit('close')" />
    <div class="modal-content modal-content-responsive">
      <button class="close-popup" type="button" @click="$emit('close')">
        <span aria-hidden="true" style="font-size: 30px; color: #d82d14;"
          >&times;</span
        >
      </button>
      <img src="../assets/gcicLogo.png" class="gcic-logo" />
      <p
        class="modal-text-content modal-text-content-responsive"
        style="padding-bottom: 0px;"
      >
        Welcome to the GCIC investor database, built in collaboration with
        AlliedCrowds.
      </p>
      <p
        class="modal-text-content modal-text-content-responsive"
        style="padding-top: 0px; padding-bottom: 80px;"
      >
        We have gathered public information about your company, where available,
        and we’re asking you to fill in any missing gaps. This information will
        be publicly available, allowing entrepreneurs in Ghana to get a better
        understanding of what funding options are available to them. If you have
        any questions, please reach out to: _.
      </p>
      <button
        @click="$emit('close')"
        class="btn-create btn-continue btn-save"
        style="margin: auto; display: block;"
      >
        Continue
      </button>
      <p
        style="float: right; padding-top: 50px; padding-right: 50px; margin-top: 16px; margin-bottom: 30px;"
      >
        In collaboration with<logo :linked="false" />
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import utils from "../components/utils.js";
import logo from "./logo.vue";

export default {
  name: "gcic-popup",
  components: {
    logo: logo
  }
};
</script>

<style scoped>
.options {
  display: inline-block;
  margin-left: 10px;
}

.gcic-logo {
  padding-left: 50px;
  padding-top: 50px;
  display: block;
  height: 132px;
  margin: auto;
  margin-left: auto;
  margin-right: auto;
}

.btn-continue {
  width: 200px;
  height: 40px;
  margin: 0 auto;
  padding: 0;
  display: inline-block;
  line-height: 30px;
  text-align: center;
}

.modal-content {
  position: fixed;
  top: 50px;
  z-index: 100;
  background-color: white;
  border: 1px solid #888;
  max-height: 90vh;
}

@media only screen and (min-width: 1200px) {
  .modal-content-responsive {
    left: 20vw;
    right: 20vw;
  }

  .modal-text-content-responsive {
    padding: 50px;
    font-size: 15px;
  }
}

@media only screen and (max-width: 1200px) and (min-width: 600px) {
  .modal-content-responsive {
    left: 10vw;
    right: 10vw;
  }

  .modal-text-content-responsive {
    padding: 50px;
    font-size: 12.5px;
  }
}

@media only screen and (max-width: 600px) {
  .modal-content-responsive {
    left: 0vw;
    right: 0vw;
  }

  .modal-text-content-responsive {
    padding: 50px;
    font-size: 10px;
  }
}

.modal-text-content {
  padding: 100px;
  padding-top: 70px;
  /* font-size: 15px; */
}

.modal-default-button {
  float: right;
}
.selected {
  color: lightgrey;
}

.dropbtn {
  cursor: pointer;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.dropdown:hover .dropbtn {
  background-color: lightgrey;
}

input[type="text"] {
  width: 200px;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  margin-top: 6px;
  margin-bottom: 16px;
  resize: vertical;
}

.overlay {
  background-color: black;
  opacity: 0.3;
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 10;
  left: 0;
  top: 0;
  overflow-x: hidden;
}

.close-popup {
  border-style: hidden;
  line-height: 0.4;
  background-color: white;
  float: right;
  padding: 30px;
}
</style>



// WEBPACK FOOTER //
// src/elements/gcicPopup.vue